export interface QuarterOption { readonly value: string /* 'HH:mm' */; readonly label: string /* 'h:mm AM' */ }

const DAY_MINUTES = 24 * 60
const pad = (n: number) => String(n).padStart(2, '0')
const toHhmm = (minutes: number) => `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`
const toMinutes = (hhmm: string) => {
  const [h, m] = hhmm.split(':').map(Number)
  return (h || 0) * 60 + (m || 0)
}
const label = (minutes: number) => {
  const h = Math.floor(minutes / 60)
  return `${h % 12 || 12}:${pad(minutes % 60)} ${h < 12 ? 'AM' : 'PM'}`
}

/** 96 options, 00:00 … 23:45. The "—" placeholder is the component's. */
export const QUARTERS: readonly QuarterOption[] =
  Array.from({ length: DAY_MINUTES / 15 }, (_, i) => ({ value: toHhmm(i * 15), label: label(i * 15) }))

/** Round to the nearest quarter ('07:08' → '07:15'); late evening stays on 23:45 rather than wrapping. */
export function q15(hhmm: string): string {
  return toHhmm(Math.min(Math.round(toMinutes(hhmm) / 15) * 15, DAY_MINUTES - 15))
}

/** After a Start pick: End = Start + 1h when End is empty or not after the new Start; otherwise End stays. */
export function endAfterPick(start: string, end: string | null): string {
  if (end && toMinutes(end) > toMinutes(start)) return end
  return toHhmm((toMinutes(start) + 60) % DAY_MINUTES)
}

/** Hours between two times; an End before Start crosses midnight (+24h). */
export function hoursBetween(start: string, end: string): number {
  return (((toMinutes(end) - toMinutes(start)) % DAY_MINUTES) + DAY_MINUTES) % DAY_MINUTES / 60
}
